import React from "react";
import { InvoiceProgressType } from "../../Types/invoiceManagementTypes";
import { Progress } from "antd";
import styles from "./invoiceManagement.module.scss";
import RefreshIcon from "../../assets/images/refresh-outline.svg";
import { invoiceManagementConsts } from "./constants";

interface ProgressNotificationDescriptionType {
  progressData?: InvoiceProgressType;
  refetchAction?: () => void;
}

const ProgressNotificationDescription = ({
  progressData,
  refetchAction,
}: ProgressNotificationDescriptionType) => {
  const { PROGRESS_COLOR, REFRESH_ALT } = invoiceManagementConsts;

  return (
    <div className={styles.notifContent}>
      <div className={styles.topContainer}>
        <span className={styles.title}>Invoice Generation</span>
        <span
          className={styles.progress}
        >{`${progressData?.processedTasks ?? 0} of ${progressData?.totalTasks ?? 0} completed!`}</span>
      </div>
      <div className={styles.bottomContainer}>
        <div className={styles.leftContainer}>
          <Progress
            showInfo={false}
            strokeColor={PROGRESS_COLOR}
            percent={progressData?.progressPercentage ?? 0}
          />
        </div>
        <div className={styles.rightContainer}>
          <div
            className={styles.iconContainer}
            onClick={(e) => {
              e.stopPropagation();
              refetchAction();
            }}
          >
            <img src={RefreshIcon} alt={REFRESH_ALT} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressNotificationDescription;
